import { compose } from "recompact"
import * as entity from "src/engine/modules/entity"
import isFunction from "lodash/isFunction"
import planEventTypesModel from "src/models/plan/models/eventTypes"
import collection from "src/hocs/collection"

const configurator = ({ planId }) => ({
  engine: entity,
  to: `planEventTypes`,
  model: planEventTypesModel(planId),
  query: {
    limit: -1,
    orderBy: `name asc`,
  },
})

export default config =>
  compose(
    collection(props => ({
      ...configurator(props),
      ...(isFunction(config) ? config(props) : config),
    })),
  )
